import { defineFetcher } from "../../api/_common/defineFetcher"
import { POST } from "../../api/_common/http"
import { SuccessInfraResponse } from "../_common/InfraResponse"
import { BadgeRegisterBody, EvaluationRegisterBody } from "./_types"
import { TOperationBody } from "./_types"

const BADGE_REQUEST_PATH = "/student/user_request/badge"
const EVALUATION_REQUEST_PATH = "/student/user_request/evalution"

export const postBadgeRequest = defineFetcher((body: BadgeRegisterBody): Promise<SuccessInfraResponse<string>> => {
  return POST(BADGE_REQUEST_PATH, body)
})

export const postEvaluationRequest = defineFetcher(
  (body: EvaluationRegisterBody): Promise<SuccessInfraResponse<string>> => {
    return POST(EVALUATION_REQUEST_PATH, body)
  }
)

export const fetchBadgeOperation = defineFetcher((body?: TOperationBody): Promise<any> => {
  return POST("/student/badge/operation", body)
})
